import { ReportFilter } from './components/ReportFilter';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useModalContext } from '@providers/ModalProvider';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const JobsReportFiltersModal = ({ onCancel, jobsFilter, jobsFilterOnChange, onSubmit }: TProps) => {
  const { closeModal } = useModalContext();

  return (
    <ModalWrapper width="400px" onCancel={onCancel}>
      <ModalTitle>Filters</ModalTitle>
      <Content>
        <ReportFilter
          jobsFilter={jobsFilter}
          jobsFilterOnChange={jobsFilterOnChange}
          handleSubmit={onSubmit}
          handleClose={closeModal}
        />
      </Content>
    </ModalWrapper>
  );
};
